<template>
  <div class="container">
    <h1>PrivacyAndPolicy</h1>
    <p>Under construction</p>
    <button @click="this.$router.go(-1)" class="btn btn-danger">Go Back</button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        
      }
    },
    created() {
    },
    methods: {
    },
  }
</script>

<style scoped>
</style>